/* tslint:disable */
/* eslint-disable */
/**
 * Get registrations to approve
 * Get registrations to approve count
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RegistrationsForCompanyClientRequestFilters,
    RegistrationsForCompanyClientRequestFiltersFromJSON,
    RegistrationsForCompanyClientRequestFiltersFromJSONTyped,
    RegistrationsForCompanyClientRequestFiltersToJSON,
} from './RegistrationsForCompanyClientRequestFilters';

/**
 * 
 * @export
 * @interface RegistrationsForCompanyClientRequest
 */
export interface RegistrationsForCompanyClientRequest {
    /**
     * 
     * @type {RegistrationsForCompanyClientRequestFilters}
     * @memberof RegistrationsForCompanyClientRequest
     */
    filters: RegistrationsForCompanyClientRequestFilters;
}

export function RegistrationsForCompanyClientRequestFromJSON(json: any): RegistrationsForCompanyClientRequest {
    return RegistrationsForCompanyClientRequestFromJSONTyped(json, false);
}

export function RegistrationsForCompanyClientRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegistrationsForCompanyClientRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'filters': RegistrationsForCompanyClientRequestFiltersFromJSON(json['filters']),
    };
}

export function RegistrationsForCompanyClientRequestToJSON(value?: RegistrationsForCompanyClientRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'filters': RegistrationsForCompanyClientRequestFiltersToJSON(value.filters),
    };
}

